module.exports = __webpack_public_path__ + "static/media/cricket.e68d044e.webp";